import { render, staticRenderFns } from "./AssignCoach.vue?vue&type=template&id=b2abf220&"
import script from "./AssignCoach.vue?vue&type=script&lang=js&"
export * from "./AssignCoach.vue?vue&type=script&lang=js&"
import style0 from "./AssignCoach.vue?vue&type=style&index=0&id=b2abf220&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports